import React from 'react';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import { Formik, Form } from 'formik';
import FormikPasswordInput from '../atom/FormikPasswordInput';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function PasswordChangePage({ setLoggedInUser }) {
    const history = useHistory();
    const { token } = useParams();
    const { notifyError, notifySuccess } = useNotify();
    const changePassword = (t, password, setSubmitting, setErrors) => {
        setErrors({});

        // TODO: a bit of a mess
        return doSwaggerCall('auth', 'resetPassword', {
            userData: {
                token: t,
                password
            }
        })
            .then(data => {
                if (!data.user) {
                    notifyError(data.message);
                    return;
                }
                notifySuccess('Password changed!');

                doSwaggerCall('auth', 'login', {
                    userData: { email: data.user.email, password }
                }).then(data2 => {
                    if (data2.user) {
                        setLoggedInUser(data2.user);
                        // navigate away
                        history.push('/');
                    } else {
                        setErrors({ api: data2.message });
                    }
                });
            })
            .catch(error => {
                console.log(error);
                notifyError(error.response.body.message);
                setSubmitting(false);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    if (token.length !== 32) {
        return <Redirect to="/" />;
    }

    return (
        <Grid container spacing={4} className="page" justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={4} lg={3}>
                <h3>Enter your new password</h3>
                <Formik
                    initialValues={{ password: '', confirm: '' }}
                    validate={({ password, confirm }) => {
                        const errors = {};
                        if (!password) {
                            errors.password = 'Missing password';
                        }
                        if (!confirm) {
                            errors.confirm = 'Missing confirm';
                        }
                        if (password !== confirm) {
                            errors.notMatching = "The 2 inputs aren't matching.";
                        }
                        return errors;
                    }}
                    onSubmit={({ password }, { setSubmitting, setErrors }) => {
                        // TODO: use Formik setErrors
                        changePassword(token, password, setSubmitting, setErrors);
                    }}
                >
                    {({ isSubmitting, errors, isValid, dirty }) => (
                        <Form>
                            <Grid spacing={3} container>
                                <FormikPasswordInput name="password" label="New password" />
                                <FormikPasswordInput name="confirm" label="Confirm password" />
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        Change password
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    {errors.api && <p>{errors.api}</p>}
                                    {errors.notMatching && <p>{errors.notMatching}</p>}
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Grid>
        </Grid>
    );
}

export default PasswordChangePage;
